import { graphql } from "../generated/gql";

export const DeleteEvaluationMutation = graphql(`
  mutation DeleteEvaluation($callID: ID!) {
    deleteEvaluation(callID: $callID) {
      ... on DeleteEvaluation {
        ID
      }
    }
  }
`);
